var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quick-list",style:({height: _vm.height})},[_c('div',{staticClass:"quick-list-tabs",style:({padding:_vm.paddingTop})},[_vm._t("cardTop")],2),_vm._v(" "),_c('div',{staticClass:"quick-list-content"},[_vm._t("cardconTent")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-680f63b1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cloud-clinic/components/ElCardContent.vue
// module id = null
// module chunks = 